let initialized = false;

export function initGA(measurementId) {
	if (!measurementId || initialized) return;

	// Inject gtag script
	const script = document.createElement('script');
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
	document.head.appendChild(script);

	window.dataLayer = window.dataLayer || [];
	function gtag(){ window.dataLayer.push(arguments); }
	window.gtag = gtag;
	gtag('js', new Date());
	gtag('config', measurementId, { send_page_view: false });
	initialized = true;
}

export function trackPageView(path) {
	const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
	if (typeof window.gtag !== 'function' || !measurementId) return;
	window.gtag('event', 'page_view', {
		page_location: window.location.origin + path,
		page_path: path
	});
}

export function trackEvent(name, params = {}) {
	if (typeof window.gtag !== 'function') return;
	window.gtag('event', name, params);
}
